/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  HealthControllerCheckLivenessQueryResponse,
  HealthControllerCheckLiveness503,
} from '../types/HealthControllerCheckLiveness.ts';

function getHealthCheckLivenessUrl() {
  const res = { method: 'GET', url: `/api/health/liveness` as const };
  return res;
}

/**
 * {@link /api/health/liveness}
 */
export async function healthCheckLiveness(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    HealthControllerCheckLivenessQueryResponse,
    ResponseErrorConfig<HealthControllerCheckLiveness503>,
    unknown
  >({ method: 'GET', url: getHealthCheckLivenessUrl().url.toString(), ...requestConfig });
  return res.data;
}
